import mongoose from "mongoose";
import { z } from "zod";

const isValidId = (id) => mongoose.Types.ObjectId.isValid(id);

export const VideoGalleryValidationSchema = z.object({
  title: z
    .string()
    .transform((val) => val.trim())
    .optional(),
  thumbnail: z.string().refine((value) => isValidId(value), {
    message: "Thumbnail image must be a valid ObjectId.",
  }),
  video_url: z
    .string()
    .url({ message: "Video URL must be a valid URL." })
    .refine((url) => url.includes("https://www.youtube.com/embed/"), {
      message: "Video URL must be a valid YouTube link.",
    })
    .transform((url) => url?.trim() || ""),
  order_number: z
    .string()
    .transform((val) => val.trim() || "1")
    .refine((val) => !isNaN(Number(val)) && Number.isInteger(Number(val)), {
      message: "Order number must be a valid number",
    })
    .refine((val) => Number(val) > 0, {
      message: "Order number must be greater than 0",
    }),
});
